























import { Vue, Component } from "vue-property-decorator";
import EducationProtocolForm from "@/components/education/EducationProtocolForm.vue";
import { EducationProtocol as IEducationProtocol } from "@/api/models/education-protocol";
import api from "@/getinfo-api";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";

@Component({ components: { CBreadCrumbs, EducationProtocolForm } })
export default class EducationProtocolEdit extends Vue {
  educationProtocol!: IEducationProtocol;
  data() {
    return {
      educationProtocol: undefined
    };
  }
  get breadcrumbs() {
    return [
      {
        to: { name: "educationProtocolList" },
        label: `${this.$tc(this.$translate.TrainingProtocols)}`
      },
      {
        to: {
          name: "educationProtocol",
          params: { id: this.educationProtocol.id }
        },
        label: this.educationProtocol.number
      },
      {
        label: this.$tc(this.$translate.Edit)
      }
    ];
  }
  getEducationProtocol() {
    api.EducationProtocolApi.get(this.$route.params.id).then(
      (res: { data: IEducationProtocol }) => {
        this.educationProtocol = res.data;
      }
    );
  }

  mounted() {
    this.getEducationProtocol();
  }
}
